import React from "react";
import Particle from "../Particle";
import "./Legal.css";

export default function Legal() {
  return (
    <>
      <Particle />
    

     <main className="legal-container">
      <h1>Mentions légales &amp; Politique de confidentialité</h1>
      <p>
        Dernière mise à jour : <strong>25/11/2025</strong>
      </p>

      {/* 1. Propriétaire */}
      <h2>1. Propriétaire du site</h2>
      <p>
        Nom : <strong>Valentin CRETON</strong>
        <br />
        Type de site : Portfolio personnel
        <br />
        Email de contact : <strong>valentin@vcreton.fr</strong>
      </p>

      {/* 2. Hébergement */}
      <h2>2. Hébergement</h2>
      <p>
        Hébergeur : <strong>Scaleway</strong>
        <br />
        Adresse : <strong>8 rue de la Ville l’Evêque, 75008 Paris, France</strong>
        <br />
        Le site fonctionne via un serveur Node.js qui peut générer des journaux
        techniques (logs).
      </p>

      {/* 3. Propriété intellectuelle */}
      <h2>3. Propriété intellectuelle</h2>
      <p>
        Tous les contenus présents sur ce site (textes, code, organisation des
        pages, éléments graphiques, projets présentés) sont protégés par le droit
        d&apos;auteur et, le cas échéant, par le droit des marques.
      </p>
      <p>
        Toute reproduction, représentation, modification, adaptation, diffusion,
        traduction ou exploitation, totale ou partielle, du contenu du site,
        sans autorisation écrite préalable, est interdite.
      </p>

      {/* 4. Code source / fork GitHub */}
      <h3> Code source et attribution</h3>
      <p>
        Ce site est basé sur un portfolio initialement publié sur GitHub :
        <br />
        <code><a href="https://github.com/soumyajit4419/Portfolio">https://github.com/soumyajit4419/Portfolio</a></code>
      </p>
      <p>
        Une partie de la structure et du design provient de ce projet.
        L&apos;auteur original est crédité conformément à sa demande.
      </p>
      <p>
        À défaut de licence open-source clairement indiquée sur le dépôt
        d&apos;origine, ce portfolio forké est utilisé à titre personnel et ne
        confère aucun droit de réutilisation, redistribution ou commercialisation
        de ce code à des tiers sans l&apos;accord de l&apos;auteur d&apos;origine.
      </p>

      {/* 5. Images IA */}
      <h2>4. Images générées par intelligence artificielle</h2>
      <p>
        Certaines images présentes sur ce site ont été générées par intelligence
        artificielle (IA), via l’outil suivant : <strong>ChatGPT</strong>.
      </p>
      <p>
        Ces images ne sont pas destinées à représenter une personne réelle
        identifiable. Elles sont utilisées uniquement à des fins visuelles et
        illustratives.
      </p>

      {/* 6. Logos d’entreprises */}
      <h2>5. Logos d&apos;entreprises</h2>
      <p>
        Les logos d&apos;entreprises affichés sur ce site, notamment dans les
        sections A propos de moi ou Projets, demeurent la propriété
        exclusive de leurs détenteurs respectifs.
      </p>
      <p>
        Ils sont utilisés uniquement à titre illustratif pour présenter des
        expériences professionnelles, collaborations ou projets, et ne sauraient
        en aucun cas impliquer une quelconque approbation ou partenariat officiel.
      </p>

      {/* 7. Données collectées / IP / pas de GA */}
      <h2>6. Données collectées</h2>
      <p>
        Ce site ne collecte aucune donnée personnelle à des fins marketing,
        publicitaires ou statistiques.
      </p>
      <p>
        En particulier :
      </p>
      <ul>
        <li>Aucun outil de suivi tel que Google Analytics n&apos;est utilisé.</li>
        <li>Aucun pixel publicitaire ou traceur tiers n&apos;est mis en place.</li>
        <li>Aucun formulaire de contact stockant des données n&apos;est utilisé
          (sauf si vous en ajoutez un).</li>
      </ul>

      <h3> Adresses IP et journaux techniques</h3>
      <p>
        Le serveur peut enregistrer automatiquement certaines informations
        techniques, notamment l&apos;adresse IP de l&apos;utilisateur, la date et
        l&apos;heure de la visite, ainsi que certaines informations liées au
        navigateur ou au système d&apos;exploitation.
      </p>
      <p>Ces données sont collectées uniquement pour les finalités suivantes :</p>
      <ul>
        <li>Assurer la sécurité du site (détection d&apos;activité suspecte).</li>
        <li>Diagnostiquer des problèmes techniques.</li>
        <li>Assurer le bon fonctionnement et la maintenance du service.</li>
      </ul>

      <h3>Base légale du traitement</h3>
      <p>
        Ce traitement est fondé sur l&apos;intérêt légitime du propriétaire du
        site, conformément à l&apos;article 6(1)(f) du Règlement Général sur la
        Protection des Données (RGPD).
      </p>

      <h3>Durée de conservation</h3>
      <p>
        Les adresses IP et journaux techniques sont conservés pour une durée
        maximale de <strong>[X jours/semaines/mois]</strong>, puis supprimés ou
        anonymisés, sauf obligation légale de conservation plus longue.
      </p>

      <h3>Destinataires des données</h3>
      <p>
        Les données techniques collectées sont accessibles uniquement :
      </p>
      <ul>
        <li>Au propriétaire du site / administrateur technique.</li>
        <li>À l&apos;hébergeur du site, dans le cadre de ses prestations
          (journaux serveurs, sécurité, support).</li>
      </ul>
      <p>
        Ces données ne sont en aucun cas revendues, louées ou cédées à des tiers
        à des fins commerciales. Elles ne sont communiquées qu&apos;en cas
        d&apos;obligation légale (demande des autorités, décision de justice, etc.).
      </p>

      {/* 8. Cookies */}
      <h2>7. Cookies</h2>
      <p>
        Ce site n&apos;utilise pas de cookies de suivi, publicitaires ou de
        mesure d&apos;audience.
      </p>
      <p>
        Seuls des cookies strictement techniques peuvent éventuellement être
        utilisés, par exemple pour le bon fonctionnement de certaines
        fonctionnalités (session, préférences techniques, etc.).
      </p>

      {/* 9. Droits RGPD */}
      <h2>8. Droits des utilisateurs (RGPD)</h2>
      <p>
        Conformément au RGPD et à la législation applicable, vous disposez,
        lorsque cela est pertinent, des droits suivants concernant les données
        vous concernant :
      </p>
      <ul>
        <li>Droit d&apos;accès à vos données.</li>
        <li>Droit de rectification si les données sont inexactes ou incomplètes.</li>
        <li>Droit d&apos;effacement (droit à l&apos;oubli), dans les limites
          prévues par la loi.</li>
        <li>Droit à la limitation du traitement.</li>
        <li>Droit d&apos;opposition, le cas échéant.</li>
      </ul>
      <p>
        Pour exercer ces droits, vous pouvez contacter :
        <br />
        <strong>valentin@vcreton.fr</strong>
      </p>

      {/* 10. Modifications */}
      <h2>9. Modifications de la présente politique</h2>
      <p>
        Le contenu de cette page (mentions légales et politique de
        confidentialité) peut être mis à jour à tout moment, notamment en cas
        d&apos;évolution légale, réglementaire ou technique.
      </p>
      <p>
        Il est recommandé de consulter régulièrement cette page pour prendre
        connaissance d&apos;éventuelles modifications.
      </p>
    </main>
</>
  );
}

